import { Wallet } from '../../interfaces/Wallet';
import { getFormattedAmount } from '../../utils/helper';
import { CountryFlagFromCode } from '../CountryFlagFromCode';

const WalletBalanceItem = ({ item }: { item?: Wallet }) => {
    return (
        <div className=' bg-white w-[208px] px-[24px] py-[20px] rounded-[24px] border border-appcolorfaintnine h-[148px]'>
            <CountryFlagFromCode code={item?.currency || ''} />

            <div className='mt-[16px]'>
                <div className='capitalize text-[22px]  font-semibold'>
                    {getFormattedAmount({
                        amount:
                            item?.walletBalance ||
                            item?.balance ||
                            item?.ledgerBalance ||
                            0,
                        compact: true
                    })}
                </div>

                <div className='uppercase text-sm  text-gray700'>
                    {item?.currency}
                </div>
            </div>
        </div>
    );
};

export default WalletBalanceItem;
